import * as React from 'react';

import { useFormContext, useWatch, FieldValues, FieldPath } from 'react-hook-form';

interface UseWatchAndSetValueProps<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>> {
  watchedFieldName: TFieldName,
  watchedFieldCondition: (watchedFieldValue: any) => boolean,
  fieldToSet: TFieldName,
  valueToSet: any,
}

function useWatchAndSetValue<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>({
  watchedFieldName,
  watchedFieldCondition,
  valueToSet,
  fieldToSet,
}: UseWatchAndSetValueProps<TFieldValues, TFieldName>) {
  const { control, setValue } = useFormContext<TFieldValues>();
  const watchedFieldValue = useWatch({ control, name: watchedFieldName });

  React.useEffect(() => {
    if (watchedFieldCondition(watchedFieldValue)) {
      setValue(fieldToSet, valueToSet);
    }
  }, [watchedFieldValue]);
}

export default useWatchAndSetValue;
